import React from "react";

const Users = () => {
    return <p>Users</p>
};

export default Users;

// TODO